/* jslint esversion: 6 */
/**
 * Menu Fixed Active
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	$window            : $(window),
	$wpadminbar        : $('#wpadminbar'),
	$header            : $('.header'),
	$section           : $('.single-attorney__section'),
	$menu              : $('.menu--section--attorney'),
	fixedThreshold     : 960,
	fixedStart         : 0,
	fixedEnd           : 0,
	windowScrollTop    : 0,
	windowScrollTopPos : 0,
};

function init() {

	if (s.$menu.length) {

		if (s.$window.width() <= s.fixedThreshold) {
			s.$menu.find('li').removeClass('current_page_item');
		} else {
			s.$menu.find('.menu__list > li:first-child').addClass('current_page_item');
		}

		events();
	}
}

function events() {

	s.$window.on('load resize scroll', function() {

		s.windowScrollTop = s.$window.scrollTop(); // window.pageYOffset;

		if (s.$window.width() <= s.fixedThreshold) {
			s.$menu.find('li').removeClass('current_page_item');
		} else {
			s.$section.each(function(index, element) {

				s.wpadminbarHeight = s.$wpadminbar.length ? parseFloat(s.$wpadminbar.css('height')) : 0;
				s.headerHeight     = s.$header.hasClass('header--active') ? parseFloat(s.$header.css('height')) : 0;

				if (s.windowScrollTop + s.wpadminbarHeight + s.headerHeight >= $(this).offset().top - 1) {
					if (s.$menu.find('a[href="#'+$(this).attr('id')+'"]').length) {
						s.$menu.find('li').removeClass('current_page_item');
						s.$menu.find('a[href="#'+$(this).attr('id')+'"]').parent().addClass('current_page_item');
					}
				}
			});
		}
	});
}

export {init as default};
